import { FEEDBACK_AREAS, type FeedbackArea } from '@/entities/feedback';

/** The area the lightbulb suggested: a whitelisted value from navigation state, nothing else. */
export function suggestedArea(state: unknown): FeedbackArea | null {
  if (typeof state !== 'object' || state === null || !('feedbackArea' in state)) return null;
  return FEEDBACK_AREAS.find((area) => area === state.feedbackArea) ?? null;
}
